import React, { useState, useEffect } from "react";
import axios from "axios";
import "semantic-ui-css/semantic.min.css";
import { useAuth } from "../../../../hook/userAuth";
import { Navigate, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { BASE_API } from "../../../../ruta-server/BaseApi";
import { Loader } from "semantic-ui-react";
import Swal from "sweetalert2";
import { ListaPracticantes } from "../../../../components/Users/TableTeachers/PracticantesProfesionales/ListaPracticantes";

function PracticantesDisponibles() {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { curso, dataDocente } = location.state || {};

  useEffect(() => {
    if (!curso) {
      navigate("/gestion-docente");
    }
  }, [navigate]);

  if (!auth?.me?.is_superuser) {
    return <Navigate to={"/"} />;
  }

  return curso ? (
    <LogicaPracticantesDisponibles
      datosCurso={curso}
      dataDocente={dataDocente}
    />
  ) : null;
}

function LogicaPracticantesDisponibles({ datosCurso, dataDocente }) {
  const { nombre_materia, clave_materia, semestre } = datosCurso.materia_data;
  const { numero_grupo } = datosCurso.grupo_data;
  const { auth } = useAuth();
  const [refetch, setRefetch] = useState(false);
  const [alumnosCalificaciones, setAlumnosCalificaciones] = useState(null);
  const [ids_alumnosCali, setIdsAlumnosCali] = useState(null);
  const [loading, setLoading] = useState(true);

  async function getAlumnosCali() {
    try {
      setLoading(true);
      const response = await axios.get(
        `${BASE_API}/api/calificacion_curso/?curso=${datosCurso.id}&docente_asesor_is_null=true`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );
      const result = response.data;
      setLoading(false);

      setAlumnosCalificaciones(result);
      const idsAlumnos = result.map((cursoCali) => cursoCali.alumno);
      setIdsAlumnosCali(idsAlumnos);
      return result;
    } catch (error) {
      setLoading(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    getAlumnosCali();
    // eslint-disable-next-line
  }, [refetch]);

  const onRefetch = () => {
    setRefetch((prev) => !prev);
  };

  async function asignarAlumno(dataAlumno, dataCalificacion) {
    const confirmMessage = `¿Estás seguro de que deseas asignar al alumno ${
      dataAlumno.matricula || dataAlumno.curp
    } como asesorado?`;

    const result = await Swal.fire({
      text: confirmMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí",
      confirmButtonColor: "#2f6d02",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "#920804",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.patch(
          `${BASE_API}/api/calificacion_curso/${dataCalificacion}/`,
          {
            docente_asesor: dataDocente.id,
          },
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          }
        );
        const result = response.data;
        onRefetch();
        return result;
      } catch (error) {
        window.location.reload();
        window.location.href = "/Login";
        throw error;
      }
    }
  }

  const formatPeriodo = (fecha) => {
    const opciones = { month: "long", year: "numeric" };
    const fechaFormateada = new Date(fecha).toLocaleDateString(
      "es-ES",
      opciones
    );
    return fechaFormateada;
  };

  return (
    <div>
      <h1 className="encabezado">PRACTICANTES DISPONIBLES</h1>
      <h1 className="encabezado">
        CURSO: <span className="nombreM">{nombre_materia} </span>{" "}
        <span> {clave_materia} </span>
      </h1>

      <h1 className="encabezado">
        GRUPO: {numero_grupo} <span> SEMESTRE: {semestre} </span> TURNO: M{" "}
        <span>
          {" "}
          PERIODO: {formatPeriodo(datosCurso.periodo_data.fecha_inicio)} -{" "}
          {formatPeriodo(datosCurso.periodo_data.fecha_fin)}
        </span>
      </h1>

      <h1 className="tituloin2"> </h1>

      <h6 className="sub">
        Gestion docente / Practicantes disponibles / Grupo {numero_grupo}
      </h6>
      {loading ? (
        <Loader active inline="centered">
          Cargando....
        </Loader>
      ) : (
        <ListaPracticantes
          alumnosCali={alumnosCalificaciones}
          asignarAlumno={asignarAlumno}
        />
      )}
    </div>
  );
}

export default PracticantesDisponibles;
